import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";   // ✅ ADDED
import t1 from "../assets/images/t-1.png";
import t2 from "../assets/images/t-2.png";
import "../styles/home.css";
import { API_CONFIG } from "../config/api";
import { generateAuthToken, generateURN } from "./hmac";

const imgs = [t1, t2];

const FeaturedTournaments = () => {
  const navigate = useNavigate();                 // ✅ ADDED
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const {host,fetchTournaments,basic}=API_CONFIG;
        const urn=generateURN();
        const authToken=generateAuthToken(urn);
        const res = await fetch(
          `https://${host}${fetchTournaments.path}`,
          {
            method: fetchTournaments.method,
            credentials: "include",
            headers:{
              Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
              urn:urn,
              authToken:authToken,
            } 
          }
          );
        const json = await res.json();
        const allData =
          json.apiResponseData?.responseData?.tournaments || [];

        const filtered = allData
          .filter((t) => t.tournamentStatus === 1)
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 3);

        setTournaments(filtered);
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTournaments();
  }, []);

  if (loading) return <div className="section">Loading Data from API...</div>;

  return (
    <div className="featured-container">
      <section className="section section-light-bg">
        <div className="section-header">
          <h2>Featured Tournaments</h2>
          <button
            className="view-all-btn"
            onClick={() => navigate("/tournaments")}   // ✅ ADDED
          >
            View All
          </button>
        </div>
      </section>

      <section className="section cards-bg">
          <div className="card-grid">
          {tournaments.length > 0 ? (
            tournaments.map((t, index) => (
              <div className="tournament-card" key={t._id || index}>
                <div className="img-container">
                  <img
                    src={imgs[index % imgs.length]}
                    alt="Chess Tournament"
                    className="tournament-img"
                  />
                </div>

                <div className="tournament-content">
                  <h3>{t.tournamentName}</h3>
                  <p className="date">
                    <strong>Date:</strong> {t.date}
                  </p>
                  <p className="description">
                    {t.info || t.description}
                  </p>
                  <button
                    className="details-btn"
                    onClick={() => navigate("/tournaments")} // ✅ ADDED
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="sign-in-tournament">
              <h1>🔒</h1>
            <h2>Sign In To See Upcoming Tournaments.</h2>
            </div>
          )}
          </div>
      </section>
    </div>
  );
};

export default FeaturedTournaments;
